<template>
  <div class="dialog_box">
    <el-dialog
      title="指派工单"
      :visible="show"
      width="437px"
      @close="dialogClose"
      top="20vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_container">
        <el-form
          ref="form"
          class="form_box"
          :model="form"
          label-width="80px"
          :rules="rules"
        >
          <el-form-item label="指派给" prop="targetUserId">
            <el-select v-model="form.targetUserId" placeholder="请选择指派给的人员">
              <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.username"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="form.remark"
              type="textarea"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      form: {
        orderId: 0,
        remark: "",
        targetUserId: null,
      },
      imgUrl: "",
      userList: [],
      rules: {
        targetUserId: [
          { required: true, message: "请选择指派给的人员", trigger: "change" },
        ]
      },
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.$http
          .queryUserList({
            page: 1,
            limit: 999999,
            isTree: false,
            userType: "个人",
          })
          .then((res) => {
            if (res.code === 0) {
              this.userList = res.data;
            } else {
              this.userList = [];
            }
          });
      }
    },
  },
  created() {},
  methods: {
    dialogClose() {
      this.$emit("update:show", false);
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.form.orderId = this.data.id
        this.$http.pointWorkOrder(this.form).then((res) => {
          if (res.code === 0) {
            // this.$message.success(res.msg);
            this.form = {};
            this.$parent.getOrderNum();
            this.$parent.getYiShengHeList();
            this.$emit("update:show", false);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
/deep/.el-dialog__body {
  overflow-y: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/views/workOrder_Audit/component/assign.vue